import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

// The inspection photos: one large photo with arrows and a strip of thumbnails; every photo when printed
export const PhotoCarousel = ({ photos, onOpenImage }) => {
    const { t } = useTranslation('reportPage');
    const [index, setIndex] = useState(0);
    const current = photos[Math.min(index, photos.length - 1)];
    const go = step => setIndex(i => (i + step + photos.length) % photos.length);

    return (
        <section id="photos" className="crs" aria-label={t('inspection.photosTitle')}>
            <div className="crs-main noprint">
                <button
                    type="button"
                    className="crs-image"
                    onClick={() => onOpenImage && onOpenImage(current.url)}
                    aria-label={current.label}
                >
                    <img src={current.url} alt={current.label} />
                </button>
                {photos.length > 1 && (
                    <>
                        <button
                            type="button"
                            className="crs-arrow prev"
                            onClick={() => go(-1)}
                            aria-label={t('layout.prevPhoto')}
                        >
                            <LeftOutlined />
                        </button>
                        <button
                            type="button"
                            className="crs-arrow next"
                            onClick={() => go(1)}
                            aria-label={t('layout.nextPhoto')}
                        >
                            <RightOutlined />
                        </button>
                        <span className="crs-count" aria-live="polite">
                            {index + 1} / {photos.length}
                        </span>
                    </>
                )}
            </div>
            {photos.length > 1 && (
                <div className="crs-thumbs noprint">
                    {photos.map((photo, i) => (
                        <button
                            type="button"
                            className={`crs-thumb${i === index ? ' on' : ''}`}
                            onClick={() => setIndex(i)}
                            aria-label={t('layout.photoOf', { n: i + 1, total: photos.length })}
                            aria-current={i === index}
                            key={photo.url || i}
                        >
                            <img src={photo.url} alt="" loading="lazy" />
                        </button>
                    ))}
                </div>
            )}
            <div className="crs-print">
                {photos.map((photo, i) => (
                    <img src={photo.url} alt={photo.label} key={photo.url || i} />
                ))}
            </div>
        </section>
    );
};
